import { useState } from "react";
import { useSelector } from "react-redux";
import { Grid, makeStyles, Typography } from "@material-ui/core";

import { Box } from "../Box";
import { Header } from "../Header";
import { XAxis } from "./chart/XAxis";
import { GroupButton } from "../GroupButton";
import { COLORS } from "../../../../theme/colors";
import { BarChartForEmissionImpact } from "./chart";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { currencyFormatter } from "../../../../services/utils";
import { Checkbox } from "../../../../components/base/Checkbox";
import { CarboonRevenueLabel, EmissionReductionLabel } from "./labels";
import { expectedCarbonRevernuesLCR, expectedEmissionReductionLCR } from "../sample";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  planTitle: {
    fontWeight: 600,
  },
  planCheckboxs: {
    marginTop: theme.spacing(0.1),
    marginBottom: theme.spacing(1.8),
  },
}));

export const LowestCarbonReduction = ({ building, onClose }) => {
  const classes = useStyles();
  const [isPowerAssetChecked, setPowerAssetChecked] = useState(false);
  const [isPowerConsumptionChecked, setPowerConsumptionChecked] = useState(false);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Box>
      <Header
        title="Lowest Carbon Emission Reduction"
        hideTenants
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FFE6E6">
        <Typography variant="h4">
          Carbon reduction & revenues of this building are below portfolio average
        </Typography>
      </InfoBox>

      <Typography className={classes.planTitle} variant="h4">
        Improvement plan
      </Typography>
      <Grid className={classes.planCheckboxs} container spacing={2}>
        <Grid item>
          <Checkbox
            checked={isPowerAssetChecked}
            text="Add power assets"
            onChange={(e) => setPowerAssetChecked(e.target.checked)}
          />
        </Grid>
        <Grid item>
          <Checkbox
            checked={isPowerConsumptionChecked}
            text="Increase power consumption"
            onChange={(e) => setPowerConsumptionChecked(e.target.checked)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Typography className={classes.chartTitle}>
            Expected Carbon Emission Reduction (tCO2)
          </Typography>
          <BarChartForEmissionImpact
            chartData={expectedEmissionReductionLCR}
            additionalBars={[{ key: "additional_emission", color: "#8DCAD3" }]}
            customLabelList={EmissionReductionLabel}
            unit="KgCo2"
          />
          <XAxis />
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.chartTitle}>Expected Carbon Revenues</Typography>
          <BarChartForEmissionImpact
            chartData={expectedCarbonRevernuesLCR}
            barColors={["#019275", "#97FF9F", "#27E7C1"]}
            additionalBars={[
              { key: "additional_carbon_rev", color: COLORS.silverSand[50] },
              { key: "additional_pwr_rev", color: "#EDC124" },
            ]}
            customLabelList={CarboonRevenueLabel}
          />
          <XAxis />
        </Grid>
      </Grid>

      <GroupButton
        buttons={[{ text: "SHARE" }, { text: "APPROVE PLAN" }]}
        additionalEl={
          <Typography style={{ fontWeight: 600, marginLeft: 4 }}>
            (COST: {currencyFormatter(0, currencySymbol)})
          </Typography>
        }
      />
    </Box>
  );
};
